import { ROUTER_BASE_URL } from '@/config/common'
import { createRouter, createWebHistory } from 'vue-router'
import { reportSGM } from '@/utils/sgm'
import routes from './pages'
import { setStore } from '@/store'
import { cacheBizSource, clearCacheBizSource } from '@/hooks/useStorage'
import { hideConfirm } from '@/hooks/usePlugin'
import { qdClick } from '@/utils/qd'
import { loadAAR } from '../hooks/useAARParams'
import { resetPageSkinTheme } from '@/core/skin'
import { preloadAssets } from '@/utils/preload'

const router = createRouter({
  history: createWebHistory(ROUTER_BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  console.log('router beforeEach', to, from)
  /** 设置页面标题 */
  if (to.name !== from.name && to.meta && typeof to.meta.title === 'string') {
    document.title = to.meta.title
  }

  if (to.meta?.themeReset) {
    resetPageSkinTheme()
  }
  /** 初始化 AAR 防刷 */
  loadAAR()

  /** 隐藏confirm */
  hideConfirm()

  console.log('-------beforeEach------', from)

  /** 清除bizSource缓存 */
  if (!from?.matched?.length) {
    console.log('首次访问应用')
    clearCacheBizSource()
  }

  /** bizSource 埋点 */
  const { bizSource = '' } = to.query || {}

  if (bizSource) {
    // 缓存
    cacheBizSource(bizSource)

    // 奇点上报
    const { clsId } = to.meta || {}
    if (clsId) {
      const clsTag = `${clsId}|bizSource`
      qdClick(clsTag, { bizSource })
    }

    // 统计上报
    reportSGM({
      type: 3,
      code: `bizSource_${bizSource}`,
      res: {
        query: to.query,
        path: to.fullPath
      }
    })
  }

  /** 缓存路径 */
  setStore('prevRoute', from)
  setStore('curRoute', to)

  /** 预加载图片 */
  preloadAssets(to?.meta?.preload || {})
  /** 进入页面 */
  next()
})

router.afterEach((to, from, failure) => {
  console.log('-------afterEach------', window.location.href, failure)
  if (failure) {
    reportSGM({
      code: 'VUE_ROUTER_ERROR_HANDLER',
      err: failure
    })
  }
})

export default router
